const md = `# Auto-Generation Pipeline

When you tick **Auto-generate narration & MP4** on the Run modal,
three background jobs chain together the moment the Playwright run
finishes.  All three are interruptible and resumable from the
run-detail page.

## Stage 1 — Narration

* **Model:** GPT-5.2 via the Emergent Universal Key.
* **Input:** the run's step log + the explicit screenshots (vision).
* **Output:** a structured narration script with one paragraph per
  scene (≈ 300–500 words for a full free-form workflow).
* **Persona-aware:** see the Personas section.  Default persona is
  *neutral instructional*.
* **Cost:** typically a few cents per script.

## Stage 2 — Voiceover

* **Provider:** ElevenLabs (configured via your account's API key
  stored in the backend \`.env\`).
* **Default voice:** **Lily — Velvety Actress** (\`pFZP5JQG7iQjIQuC4Bku\`).
* **Override:** the run-detail page's voiceover panel lets you re-roll
  with any other ElevenLabs voice your account has access to.
* **Output:** MP3 of the narration script, length ≈ 1× narration words
  / 2.4 words-per-second.

## Stage 3 — Final MP4

* **Tool:** ffmpeg, native binary inside the backend container.
* **Inputs:** the Playwright \`.webm\` (video, no audio) + the voiceover
  MP3.
* **Output:** an MP4 with H.264 video + AAC audio, viewable anywhere.
* **Naming:** \`stitched_<timestamp>_<random>.mp4\` saved under
  \`/app/backend/storage/runs/<run_id>/\`.

## Manually triggering a stage

If you skipped auto-pipeline at run time, the run-detail page exposes
**Generate narration**, **Generate voiceover**, and **Stitch MP4**
buttons in their respective panels.  They run sequentially — generate
the narration first.

## When something fails

Each stage writes an \`error_message\` field on the narration script
document if it fails.  Common causes:

* **No Emergent LLM key balance** → narration fails.  Profile →
  Universal Key → Add Balance.
* **No ElevenLabs API key in \`.env\`** → voiceover fails.  Ask an
  admin to add \`ELEVENLABS_API_KEY=…\` and restart the backend.
* **ffmpeg missing** → final video fails.  The container ships it; if
  you see this, file a bug.

The pipeline never silently swallows errors — you'll always see a
red badge on the relevant panel with the exact message.
`;

export default md;
